import $ from "jquery"
var rangeControlPicker = null;
export function setupBusinessPricingCalculator() {
    $(document).ready(() => {
        if (document.getElementById("range-picker-control")) {
            rangeControlPicker = document.getElementById("range-picker-control")
            initRangeSelector(rangeControlPicker);
            initToggleForPanel();
            listenCheckboxes();
            setNummber(100);
            initDeviceCounter()
            initToggle();
            $(".option-base-label-wrapper[data-discount] label").click()
            if ($(window).innerWidth() <= 900) {
                $("#lockwipe .option-content-header").text("Tracking & Monitoring")
                $("#lockwipe .option-content-description").text("Location Activity Tracking")
                $("#tracking-monitoring .option-content-header").text("Actions on Device")
                $("#tracking-monitoring .option-content-description").text("Lock & Wipe")
            }

            $("#basePricePlace").html(basePrice);
            $("#networkPricePlace").html(networkPrice);
            $("#userActivityPricePlace").html(userActivityPrice);
            $("#sendAlertsPricePlace").html(sendAlertsPrice);
            $("#dataPricePlace").html(dataPrice);
            $("#discountPricePlace").html(discountPrice);
            $("#discountPlaceHolderPricePlace").html(discountPlaceHolder);

        }
        
        if (!['$', '£', '€'].includes($(".dollar-sign").first().text())) {
            $(".dollar-sign").text("$")
        }  

        applyDeviceCounter();
        listenInput();

        //quotepage
        if (document.getElementById("quote-page")) {
            checkState();
            listenSubmit();
            const urlParams = new URLSearchParams(window.location.search);
            const type = urlParams.get('type');
            if (type) {
                $("#organization-specialization").val(type)
                $("#organization-specialization").closest(".float-container ").addClass("active")
                switch(type) {
                    case "Business":
                        thankLink = "business"
                        break;
                    case "Education":
                        thankLink = "edu"
                        break;
                    case "Non-profit":
                        thankLink = "nonprofit"
                        break;
                    default:
                        thankLink = "business";
                }
            }
            else {
                thankLink = "business";
            }
            checkEducationPage();


        }
    })
}

function initToggle() {
    $("#toggle").change(() => {
        if ($("#toggle").is(':checked')) {
            $(".billing-row").addClass("checked");
            isAnnualSelected = false;
        }
        else {
            $(".billing-row").removeClass("checked");
            isAnnualSelected = true;
        }
        updatePrice();
    })
}

var countToSet = 150;
var dedicatedManagerPrice = 200;
let isDiscountEnable = false;
var minimumDevices = 11;
var itemsForPixel = 0;
var actualDevicesCount = 150;
let isAnnualSelected = true;
const params = new URLSearchParams(location.search);
let isEducationQuote = window.location.href.includes("edu-quote") || window.location.href.includes("isEduDemo");

function initRangeSelector(elmnt) {
    var totalWidth = $(".range-selection-track").innerWidth();
    var rangePickerWidth = $("#range-picker-control").innerWidth();

    var pos1 = 0,
        pos3 = 0;

    var maxCount = 300 - minimumDevices;
    itemsForPixel = maxCount / (totalWidth - (rangePickerWidth - 16));

    elmnt.onmousedown = dragMouseDown;
    // elmnt.ontouchstart = dragMouseDown;
    elmnt.addEventListener('touchstart', dragMouseDown, { passive: false });

    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        console.log(e)
        // get the mouse cursor position at startup:
        pos3 = e.clientX || (e.touches ? e.touches[0].clientX : null);
        console.log(pos3)
        document.onmouseup = closeDragElement;
        // document.ontouchend = closeDragElement;
        elmnt.addEventListener('touchend', closeDragElement, { passive: false });

        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
        // document.ontouchmove = elementDrag;
        elmnt.addEventListener('touchmove', elementDrag, { passive: false });

    }

    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        if (e.touches) {
            pos1 = -(e.changedTouches[0].clientX - pos3);
        }
        else {
            pos1 = pos3 - e.clientX
        }
        pos3 = e.clientX || (e.touches ? e.changedTouches[0].clientX : null);

        $("#range-picker-control").css('cursor', 'grab')

        if ((elmnt.offsetLeft - pos1) > (totalWidth - (rangePickerWidth / 2) - 41)) {
            return
        }

        if ((elmnt.offsetLeft - pos1) < (0 - (rangePickerWidth / 2) + 41)) {
            return
        }

        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        var posForUnselected = elmnt.offsetLeft - pos1 + ((rangePickerWidth / 2) - 41);

        if (posForUnselected < 0) {
            posForUnselected = 0;
        }

        countToSet = (itemsForPixel * posForUnselected).toFixed(0);

        if (countToSet > maxCount) {
            countToSet = maxCount
        }

        console.log(countToSet)
        actualDevicesCount = parseInt(countToSet) + minimumDevices;
        $(".range-selection-unselected").css("left", posForUnselected + "px")
        $("#devices-count-input").val(parseInt(countToSet) + minimumDevices)
        updatePrice();
    }

    function closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;
        document.ontouchend = null;
        document.ontouchmove = null;
        $("#range-picker-control").css('cursor', 'pointer')
    }
}

function setNummber(number) {
    countToSet = number;
    actualDevicesCount = countToSet;
    let requiredWidth = (number - minimumDevices) / itemsForPixel;
    $(".range-selection-unselected").css("left", requiredWidth + "px")
    rangeControlPicker.style.left = (requiredWidth - 10) + "px";
    updatePrice();
}

function initDeviceCounter() {
    $('#devices-count-input').keypress(function (e) {
        var charCode = (e.which) ? e.which : event.keyCode

        if (e.charCode == 13) {
            // Cancel the default action on keypress event
            e.preventDefault();
            updateDeviceNumberCheck();
        }

        if (String.fromCharCode(charCode).match(/[^0-9]/g))
            return false;
    });

    // $('#devices-count-input').keyup(function (e) {    
    //     $('#devices-count-input').change();                   
    // });   
    $('#devices-count-input').focusout(
        debounce(
            () => {
                updateDeviceNumberCheck()
            }, 0))
}

function updateDeviceNumberCheck() {
    let el = $('#devices-count-input');
    if (el.val() < 11) {
        el.val(11)
    }
    if (el.val() > 300) {
        el.val(300)
    }
    console.log(el.val())
    setNummber(el.val())
}


function debounce(callback, delay) {
    let timeout;
    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(callback, delay);
    }
}




function initToggleForPanel() {
    $(".option-base-label-wrapper").click(function (event) {
        $(this).toggleClass("toggled");
    })
}

function listenCheckboxes() {
    $(".option-base-label-wrapper.gray input").change(function () {
        if ($(this).is(":checked")) {
            $(this).closest(".option-base-label-wrapper").addClass("switchOn")
        }
        else {
            $(this).closest(".option-base-label-wrapper").removeClass("switchOn")
        }

        let dataPrice = $(this).closest(".option-base-label-wrapper").attr("data-price");
        let yearPrice = $(this).closest(".option-base-label-wrapper").attr("data-years");
        if (!dataPrice && !yearPrice) {
            isDiscountEnable = $(this).is(":checked");
            if (isDiscountEnable) {
                $(".option-base-label-wrapper.gray[data-price][data-for-discount]").addClass("opacity")
                // $(".option-base-label-wrapper.gray[data-price][data-for-discount]").addClass("switchOn")
                $(".option-base-label-wrapper.gray[data-price][data-for-discount] input").prop("checked", true);
                $(".option-base-label-wrapper.gray[data-discount='true']").addClass("switchOn")
            }
            else {
                $(".option-base-label-wrapper.gray[data-price][data-for-discount]").removeClass("opacity")
                $(".option-base-label-wrapper.gray[data-price][data-for-discount]").removeClass("switchOn")
                $(".option-base-label-wrapper.gray[data-price][data-for-discount] input").prop("checked", false);
                $(".option-base-label-wrapper.gray[data-discount='true']").removeClass("switchOn")
            }
        }
        else {
            isDiscountEnable = $(".option-base-label-wrapper.gray[data-price][data-for-discount] input").not(':checked').length == 0;
            if (isDiscountEnable) {
                $(".option-base-label-wrapper.gray[data-discount='true']").addClass("switchOn")
                $(".option-base-label-wrapper.gray[data-discount='true'] input").prop("checked", true);
                $(".option-base-label-wrapper.gray[data-price][data-for-discount]").addClass("switchOn")
                $(".option-base-label-wrapper.gray[data-price][data-for-discount]").addClass("opacity")
            }
            else {
                $(".option-base-label-wrapper.gray[data-discount='true']").removeClass("switchOn")
                $(".option-base-label-wrapper.gray[data-discount='true'] input").prop("checked", false);
                // $(".option-base-label-wrapper.gray[data-price][data-for-discount]").removeClass("switchOn")
                $(".option-base-label-wrapper.gray[data-price][data-for-discount]").removeClass("opacity")
            }
        }

        updatePrice();
    })
}

function cleanStorageState() {
    localStorage.removeItem("networkPrice");
    localStorage.removeItem("userActivityPrice");
    localStorage.removeItem("sendAlertsPrice");
    localStorage.removeItem("dataPrice");
}

function addStorageState(item) {
    localStorage.setItem(item, true);
}


function updatePrice() {
    cleanStorageState()

    let pricePerDevice = basePrice;
    isDiscountEnable ? pricePerDevice += discountPrice : null
    $(".option-base-label-wrapper.gray input").each(function (index) {
        let dataPrice = $(this).closest(".option-base-label-wrapper").attr("data-price");
        let isDiscount = $(this).closest(".option-base-label-wrapper").attr("data-for-discount");
        console.log(index)
        if ($(this).is(":checked") && dataPrice && isDiscount) {
            console.log(dataPrice)
            addStorageState(dataPrice)
            if (!isDiscountEnable) {
                pricePerDevice += priceOptions[dataPrice];
                console.log(dataPrice)
            }
        }
        else if ($(this).is(":checked") && dataPrice && !isDiscount) {
            pricePerDevice += priceOptions[dataPrice]
            console.log(dataPrice)
            addStorageState(dataPrice)
        }
    });

    if (actualDevicesCount == 300) {
        $(".plus-sign-wrapper").show()
        $(".submit-button-wrapper .quote-link").css("display", "flex");
        $(".submit-button-wrapper .demo-link").css("display", "none");
        $(".contact-sales-label").css("display", "flex");
        $(".total-price-wrapper").hide();
    }
    else {
        $(".plus-sign-wrapper").hide()
        $(".submit-button-wrapper .quote-link").css("display", "none");
        $(".submit-button-wrapper .demo-link").css("display", "flex");
        $(".contact-sales-label").css("display", "none");
        $(".total-price-wrapper").show();
    }

    console.log(pricePerDevice, pricePerDevice)

    let totalPrice = (pricePerDevice) * actualDevicesCount
    if (!isAnnualSelected) {
        $(".total-amount-price").text(`${((totalPrice * 1.4) / 12).toFixed(0)}`)
        $(".total-price-wrapper-label").text("/ month")
    }
    else {
        $(".total-amount-price").text(`${totalPrice}`)
        $(".total-price-wrapper-label").text("/ year")
    }

}

$(document).on('click', '#range-picker-control', function (e) {
    let center = $(this).innerWidth() / 2;
    if (e.offsetX > center) {
        $('#devices-count-input').val(parseInt($('#devices-count-input').val()) + 1)
    } else {
        $('#devices-count-input').val(parseInt($('#devices-count-input').val()) - 1)
    }
    updateDeviceNumberCheck()
});
//quotePage 
let email = '';
let firstName = '';
let lastName = '';
let phoneNumber = '';
let organizationName = '';
let organizationType = '';
let numberOfDevicesMacOs = '';
let numberOfDevicesWindows = '';
let NumberOfDevicesIos = '';
let numberOfDevicesChromeOs = '';
let numberOfDevicesAndroid = '';
let addons = '';
let notes = '';

function checkState() {
    if (localStorage.getItem("networkPrice")) {
        $("#networkPrice").prop("checked", true);
    }

    if (localStorage.getItem("userActivityPrice")) {
        $("#userActivityPrice").prop("checked", true);
    }

    if (localStorage.getItem("sendAlertsPrice")) {
        $("#sendAlertsPrice").prop("checked", true);
    }

    if (localStorage.getItem("dataPrice")) {
        $("#dataPrice").prop("checked", true);
    }
}

function listenSubmit() {
    $(".quote-link").click(function(event) {
        let isValid = true;
        let isCallPage = $(this).hasClass("call-link");
        let tempAddons = [];
        addons = '';
        $(".error-block").hide();

        event.preventDefault();

        if (isCallPage) {
            $("#organization-specialization").val("MSP")
            $("#organization-specialization").closest(".float-container ").addClass("active")
        }
        else {
            let sum = 0;
            $(".device-counter-input input").each(function(index, element) {
                sum += parseInt($(element).val());
            })

            if (sum < 11) {
                $(".b2c-pricing").show();
                return
            }
            
            $(".b2c-pricing").hide();
            numberOfDevicesWindows = $("#numberOfDevicesWindows").val();
            NumberOfDevicesIos = $("#NumberOfDevicesIos").val();
            numberOfDevicesMacOs = $("#numberOfDevicesMacOs").val();
            numberOfDevicesChromeOs = $("#numberOfDevicesChromeOs").val();
            numberOfDevicesAndroid = $("#numberOfDevicesAndroid").val();
        }


        email = $("#work_email").val();
        firstName = $("#first_name").val();
        lastName = $("#last_name").val();
        phoneNumber = $("#phone_number").val();
        organizationName = $("#org_name").val();
        organizationType = $("#organization-specialization").val();
        notes = $("#notes").val();


        if (!isEducationQuote) {
            $(".container-custom-checkbox").each(function() {
                if ($(this).find("input").is(":checked")) {
                    tempAddons.push($(this).closest(".main-form-column-item-description").text().trim())
                }
            })
    
            addons = tempAddons.join(", ");
        }
 

        if (!email) {
            $("#work_email").closest(".signup__form-block").find(".error-block").show();
            isValid = false;
        }

        if (!firstName) {
            $("#first_name").closest(".signup__form-block").find(".error-block").show();
            isValid = false;
        }

        if (!lastName) {
            $("#last_name").closest(".signup__form-block").find(".error-block").show();
            isValid = false;
        }

        if (!organizationName) {
            $("#org_name").closest(".signup__form-block").find(".error-block").show();
            isValid = false;
        }
        if (!phoneNumber) {
            $("#phone_number").closest(".signup__form-block").find(".error-block").show();
            isValid = false;
        }
        console.log("phone", phoneNumber)


        if (!organizationType) {
            $("#organization-specialization").closest(".signup__form-block").find(".error-block").show();
            isValid = false;
        }

        if (!isValid) {
            return
        }


        let request = {
            email,
            firstName,
            lastName,
            phoneNumber,
            organizationName,
            organizationType,
            numberOfDevicesMacOs,
            numberOfDevicesWindows,
            NumberOfDevicesIos,
            numberOfDevicesChromeOs,
            numberOfDevicesAndroid,
            addons,
            notes
        }
        let link = '';
        if ($(this).hasClass("demo-link")) {
            link = "https://hooks.zapier.com/hooks/catch/5548812/brxaozd/";
        }
        else if (isCallPage) {
            link = "https://hooks.zapier.com/hooks/catch/5548812/bc56d3m/"
        }
        else {
            link = 'https://hooks.zapier.com/hooks/catch/5548812/brxzdhp/'
        }
       
        $.ajax({
            type: "POST",
            url: link,
            data: request,
            success:  function(data) {
                console.log(data); 
                window.location.href = `/en/${thankLink}/thank-you`;  
            },
            error: function (jqXHR, exception) {
                console.log(jqXHR, exception)
            },
            dataType: 'json'
          });

        console.log(request);

        //https://hiddenapp.test
        
    })
}

var thankLink = "";

function listenInput() {
    $("[name='organization_industry']").change(function() {
        switch($(this).val()) {
            case "Business":
                thankLink = "business"
                break;
            case "Education":
                thankLink = "edu"
                break;
            case "Non-profit":
                thankLink = "nonprofit"
                break;
        }
        console.log(thankLink)
    })
}


function applyDeviceCounter() {
    $('.device-counter-input input').keypress(function (e) {
        var charCode = (e.which) ? e.which : event.keyCode
        if (String.fromCharCode(charCode).match(/[^0-9]/g))
            return false;
    });

    $('.device-counter-input .minus-wrapper').click(function () {
        let input = $(this).closest(".device-counter-input").find("input");
        if (input.val() != 0) {
            input.val(parseInt(input.val()) - 1)
        }
    })

    $('.device-counter-input .plus-wrapper').click(function () {
        let input = $(this).closest(".device-counter-input").find("input");
        input.val(parseInt(input.val()) + 1)
    })
}


function checkEducationPage() {
    if (isEducationQuote) {
        $("#organization-specialization").val("Education");
        $("#organization-specialization").closest(".float-container ").addClass("active");
        $("#organization-specialization").prop('disabled', true);
        $("#organization-specialization").closest(".signup__form-block").css('display', "none");
        $("#org_name").closest(".signup__form-block").css('width', "100%");
        thankLink = "edu"
    }
}